<form [formGroup]="employeeForm">
    <div class="field-container">
        <mat-form-field>
            <mat-label>First Name</mat-label>
            <input matInput #input required minlength="2" maxlength="50" formControlName="firstName"/>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Last Name</mat-label>
            <input matInput #input required minlength="2" maxlength="50" formControlName="lastName"/>
        </mat-form-field><br>
        <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput #input required maxlength="255" formControlName="email"/>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Phone</mat-label>
            <input matInput #input required maxlength="15" formControlName="phone"/>
        </mat-form-field><br>
        <mat-form-field>
            <mat-label>Address Line 1</mat-label>
            <input matInput #input required maxlength="150" formControlName="addressLine1"/>
        </mat-form-field><br>
        <mat-form-field>
            <mat-label>Address Line 2</mat-label>
            <input matInput #input required maxlength="150" formControlName="addressLine2"/>
        </mat-form-field><br>
        <mat-form-field>
            <mat-label>Address Line 3</mat-label>
            <input matInput #input maxlength="150" formControlName="addressLine3"/>
        </mat-form-field>
        <app-countries-component (messageEvent)="receiveMessage($event)"/>
    </div>
</form>